export default __webpack_public_path__ + "static/media/annotated_slides.908d0ade.svg";